export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./curacao.vue?vue&type=template&id=31e300ba&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/curacao.vue?vue&type=template&id=31e300ba&scoped=true
// module id = glyp
// module chunks = 0